export default "__VITE_ASSET__BhQ2hEBu__"